import React, { useState, useEffect } from "react";
import useGetPositionById from "../../Hooks/useGetPositionById";
import "./Autocomplete.css";
import ReactDOM from "react-dom";

export default function Autocomplete(props) {
  const getPositionById = useGetPositionById();
  const [autoComplete, setAutoComplete] = useState({
    currentData: [],
    currentValue: props.value ? props.value : ""
  });
  
  useEffect(() => {
    setAutoComplete({...autoComplete, currentValue: props.value})
    
  }, [props.value]);
  
  const handleChange = (e) => {
    
   // setAutoComplete({...autoComplete,
    //  currentValue: e.target.value,
    //});
    getSuggestion(e);
    if (props.onChange) props.onChange(e, e.target.value)
  };

  const handleClick = (e, item) => {
    setAutoComplete({...autoComplete,
      currentValue: item.item,
      currentData: [],
    });
    props.onSelectedItem(e, item)
  };
  
  const isResultatVisible = () => {
    return autoComplete.currentData.length > 0;
  };

  const getSuggestion = (e) => {
    const input = e.target.value.toLowerCase();
    const position = getPositionById(e, props.id)
    if (input != "")
      setAutoComplete({left:position[0],top:position[1],
        currentValue:input,
        currentData: props.data.filter((item) =>(item.item + "").toLowerCase().includes(input.toLowerCase())).slice(0, 10),
      });
    else
      setAutoComplete({left:position[0],top:position[1],currentValue:input, currentData: []});
  };
 
  const getMatchedIndices = (text, input) =>  {
    var matchedIndices = [];
    var indices = text.toString().indexOf(input);
    while (indices != -1) {
      matchedIndices.push(indices);
      indices = text.toString().indexOf(input, indices + 1);
    }
    return matchedIndices;
  }

  const getMatchedText = (text, indices, startTextIndex, inputLength)  => {
    var n = indices.length;
    if (n == 0)
      return (
        <strong>
          {text.toString().substring(startTextIndex, text.length)}
        </strong>
      );
    var startMatchedIndexValue = indices[0];
    var nextIndex = startMatchedIndexValue + inputLength;

    return (
      <span>
        <strong>
          {text.toString().substring(startTextIndex, startMatchedIndexValue)}
        </strong>
        {text.toString().substring(startMatchedIndexValue, nextIndex)}
        {getMatchedText(text, indices.slice(1, n), nextIndex, inputLength)}
      </span>
    );
  }

  const getText = (text, input) => {
    var value = text;
    if (input != "" && props.emphasised) {
      var indices = getMatchedIndices(
        text.toLowerCase(),
        input.toLowerCase()
      );
      value = getMatchedText(text, indices, 0, input.length);
    }
    
    return value;
  };

  const getStyle = () => {
    var style = {width:"290px", height:"35px" 
    , fontSize:"14px"
    , border:"1px solid #cccccc" 
    , fontFamily:"arial, sans-serif"
    , color:"#212121"
    , backgroundColor:"transparent"
    }
    if(props.style.width) 
      style ["width"] = props.style.width ;

    if(props.style.height) 
      style ["height"] = props.style.height;
      
    if(props.style.fontSize) 
      style ["fontSize"] = props.style.fontSize;
   
    if(props.style.fontFamily) 
      style ["fontFamily"] = props.style.fontFamily;
    if(props.style.color) 
      style ["color"] = props.style.color;
    if(props.style.resize) 
      style ["resize"] = props.style.resize;
    if(props.style.overflow) 
      style ["overflow"] = props.style.overflow;

    if(props.isWrapped) 
      style ["border"] = "none";

    if(props.onLyBottom) {
      if(props.style.border) 
        style ["border"] = props.style.border;
      else
        style ["border"] = undefined;
     
    }
    
    return style;
  }

  const getResultatStyle = () => {
    var style = {width:"312px",
    border: "1px solid #008dff",
    fontSize: "14px",
    fontFamily: "arial, sans-serif",
    color: "#212121",
    visibility: isResultatVisible() ? "visible" : "hidden",
            /*height: state.currentData.length * 25,*/
    }
    
    if(props.containerStyle.width) 
      style ["width"] = props.containerStyle.width ;
      
    if(props.style.fontSize) 
      style ["fontSize"] = props.style.fontSize;
   
    if(props.style.fontFamily) 
      style ["fontFamily"] = props.style.fontFamily;
    if(props.style.color) 
      style ["color"] = props.style.color;
   
      style ["left"] = autoComplete.left 
      style ["top"] = autoComplete.top +  parseInt(props.style.height.slice(0,-2)) + 10
      style ["position"] = "absolute"
   
    return style;
  }
  
    return (
      <React.Fragment >
        
          <input
            id={props.id}
            type={props.type ? props.type : "text"}
            value={autoComplete.currentValue}
            placeholder={props.placeholder}
            style={getStyle()}
            className={
              isResultatVisible() ? 
                 props.onLyBottom ? "onlyBottomInput" : "notEmptyInput" 
                 : 
                 props.onLyBottom ? "onlyBottom" : "emptyInput"
            }
            onKeyPress={(e) => props.onKeyPress && props.onKeyPress(e) }
            onBlur={(e) => props.onBlur && props.onBlur(e) }
            onChange={(e) => handleChange(e)}
            
          />
          
       {isResultatVisible() ? ReactDOM.createPortal(
          <div className="resultatInput" style={getResultatStyle()}>
            <ul className="ulautocomplete">
              {autoComplete.currentData.map((item, index) => (
                <li className="liautocomplete"
                  key={index}
                  onClick={(e) => handleClick(e, item)}>
                  {getText(item.item, autoComplete.currentValue)}
                </li>))}
            </ul>
          </div>,
            document.body
          )
        : null}
        
      </React.Fragment>
    );
  }

